import translate from '../i18n/config';
import { Modules, AuthRoutes, PermissionActionsEnum, PermissionModulesEnum, RouteParamsTypes } from '../enums';
import { Menu } from '../interfaces/common';


export const TABLE_CONSTANTS = {
  defaultPerPage: 10,
  noRecordsFound: translate.t('common.table.noRecordsFound'),
};

export const STATUS = {
  active: 'ACTIVE',
  inactive: 'INACTIVE',
};

export const Regex = {
  email: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\d])(?=.*[^A-Za-z0-9\s])\S{8,128}$/,
  floatValues: /^\d+(\.\d{1,2})?$/,
  floatWithNegative: /^-?\d+(\.\d{1,2})?$/,
  percentPattern: /^(?:\d{1,2}(?:\.\d{1,2})?|100(?:\.0{1,2})?)$/,
  website: /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/,
  code: /^[a-z0-9_]+$/,
  gst: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
};

export const MenuTextMapping = {
  dashboard: 'dashboard',
  products: 'products',
  masters: 'masters',
  system: 'system',
  iam: 'iam',
  tenants: 'tenants',
  renewals: 'renewals',
  featureFlags: 'featureFlags',
  notificationsOutbox: 'notificationsOutbox',
  reports: 'reports',
  auditLog: 'auditLog',
  dsar: 'dsar',
  logout: 'logout',
  blank: '',
};

export const RoutesMapping = {
  [MenuTextMapping.dashboard]: [AuthRoutes.dashboard],
  [MenuTextMapping.renewals]: [AuthRoutes.renewals, AuthRoutes.subscriptions, AuthRoutes.payments],
  [MenuTextMapping.featureFlags]: [AuthRoutes.featureFlags],
  [MenuTextMapping.notificationsOutbox]: [AuthRoutes.notificationsOutbox],
  [MenuTextMapping.reports]: [AuthRoutes.reports],
  [MenuTextMapping.auditLog]: [AuthRoutes.auditLog],
  [MenuTextMapping.dsar]: [AuthRoutes.dsar],
};

export const ROUTES_PERMISSIONS_BINDING = {
  masters: [
    {
      [PermissionModulesEnum.Masters]: [
        PermissionActionsEnum.View,
        PermissionActionsEnum.Add,
        PermissionActionsEnum.Update,
        PermissionActionsEnum.Delete,
      ],
    },
  ],
};

export const Menus: Menu[] = [
  {
    text: translate.t('layout.pageTexts.menus.dashboard'),
    id: MenuTextMapping.dashboard,
    sectionLabel: 'OPERATE',
    redirectsTo: Modules.home + AuthRoutes.dashboard,
    icon: <i className="menu-icon tf-icons ri-home-smile-line"></i>,
  },
  {
    text: translate.t('tenants.pageTexts.menuGroup'),
    id: MenuTextMapping.tenants,
    redirectsTo: Modules.tenants + RouteParamsTypes.blank,
    icon: <i className="menu-icon tf-icons ri-building-4-line"></i>,
    accessibleTo: ['tenant:view'],
  },
  {
    text: translate.t('layout.pageTexts.menus.subscriptions.root'),
    id: MenuTextMapping.renewals,
    icon: <i className="menu-icon tf-icons ri-refresh-line"></i>,
    childrens: [
      {
        text: translate.t('layout.pageTexts.menus.subscriptions.list'),
        redirectsTo: Modules.home + AuthRoutes.subscriptions,
        accessibleTo: ['subscription:view'],
      },
      {
        text: translate.t('layout.pageTexts.menus.subscriptions.payments'),
        redirectsTo: Modules.home + AuthRoutes.payments,
        accessibleTo: ['payment:view'],
      },
      {
        text: translate.t('layout.pageTexts.menus.subscriptions.renewals'),
        redirectsTo: Modules.home + AuthRoutes.renewals,
        accessibleTo: ['tenant:view'],
      },
    ],
  },
  {
    text: translate.t('layout.pageTexts.menus.featureFlags'),
    id: MenuTextMapping.featureFlags,
    redirectsTo: Modules.home + AuthRoutes.featureFlags,
    icon: <i className="menu-icon tf-icons ri-toggle-line"></i>,
    accessibleTo: ['feature-flag:view'],
  },
  {
    text: translate.t('layout.pageTexts.menus.notificationsOutbox'),
    id: MenuTextMapping.notificationsOutbox,
    redirectsTo: Modules.home + AuthRoutes.notificationsOutbox,
    icon: <i className="menu-icon tf-icons ri-mail-send-line"></i>,
    accessibleTo: ['report:view'],
  },
  {
    text: translate.t('layout.pageTexts.menus.reports'),
    id: MenuTextMapping.reports,
    redirectsTo: Modules.home + AuthRoutes.reports,
    icon: <i className="menu-icon tf-icons ri-file-chart-line"></i>,
    accessibleTo: ['report:view'],
  },
  {
    text: translate.t('layout.pageTexts.menus.auditLog'),
    id: MenuTextMapping.auditLog,
    redirectsTo: Modules.home + AuthRoutes.auditLog,
    icon: <i className="menu-icon tf-icons ri-file-list-3-line"></i>,
    accessibleTo: ['audit:view'],
  },
  {
    text: translate.t('layout.pageTexts.menus.dsar'),
    id: MenuTextMapping.dsar,
    redirectsTo: Modules.home + AuthRoutes.dsar,
    icon: <i className="menu-icon tf-icons ri-shield-check-line"></i>,
    accessibleTo: ['compliance:manage'],
  },
  {
    text: translate.t('layout.pageTexts.menus.mastersGroup'),
    id: MenuTextMapping.masters,
    sectionLabel: 'DIRECTORY',
    icon: <i className="menu-icon tf-icons ri-price-tag-3-line"></i>,
    childrens: [
      {
        text: translate.t('masters.statuses.types.tenantStatuses'),
        redirectsTo: Modules.masters + AuthRoutes.tenantStatuses,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.statuses.types.subscriptionStatuses'),
        redirectsTo: Modules.masters + AuthRoutes.subscriptionStatuses,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.statuses.types.paymentStatuses'),
        redirectsTo: Modules.masters + AuthRoutes.paymentStatuses,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.billingCycles.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.billingCycles,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.currencies.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.currencies,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.products.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.productMaster,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.countries.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.countries,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.timezones.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.timezones,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.categories.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.categories,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.roles.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.roles,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.configKeys.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.configKeys,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.notifTemplates.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.notifTemplates,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.receiptTemplates.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.receiptTemplates,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
      {
        text: translate.t('masters.plans.list.pageTexts.title'),
        redirectsTo: Modules.masters + AuthRoutes.plans,
        accessibleTo: ROUTES_PERMISSIONS_BINDING.masters,
      },
    ],
  },
  {
    text: translate.t('system.globalConfig.pageTexts.title'),
    id: MenuTextMapping.system,
    sectionLabel: 'SYSTEM',
    redirectsTo: Modules.system + AuthRoutes.globalConfig,
    icon: <i className="menu-icon tf-icons ri-settings-3-line"></i>,
    accessibleTo: ['config:manage'],
  },
  {
    text: translate.t('system.branding.pageTexts.title'),
    id: MenuTextMapping.system,
    redirectsTo: Modules.system + AuthRoutes.branding,
    icon: <i className="menu-icon tf-icons ri-palette-line"></i>,
    accessibleTo: ['config:manage'],
  },
  {
    text: translate.t('system.dataManagement.pageTexts.title'),
    id: MenuTextMapping.system,
    redirectsTo: Modules.system + AuthRoutes.dataManagement,
    icon: <i className="menu-icon tf-icons ri-database-2-line"></i>,
    accessibleTo: ['tenant:retention-manage'],
  },
  {
    text: translate.t('iam.pageTexts.menuGroup'),
    id: MenuTextMapping.iam,
    icon: <i className="menu-icon tf-icons ri-shield-user-line"></i>,
    childrens: [
      {
        text: translate.t('iam.internalUsers.list.pageTexts.title'),
        redirectsTo: Modules.iam + AuthRoutes.internalUsers,
        accessibleTo: ['user:invite'],
      },
      {
        text: translate.t('iam.accessReviews.list.pageTexts.title'),
        redirectsTo: Modules.iam + AuthRoutes.accessReviews,
        accessibleTo: ['access-review:manage'],
      },
      {
        text: translate.t('tenantUsers.list.pageTexts.title'),
        redirectsTo: Modules.iam + AuthRoutes.tenantUsers,
        accessibleTo: ['user:invite'],
      },
    ],
  },
];

export const VALIDATION_FIELD_MAPPING = {
  username: 'username',
  first_name: 'first_name',
  password: 'password',
  email: 'email',
  oldPassword: 'oldPassword',
  newPassword: 'newPassword',
  confirmPassword: 'confirmPassword',
  role: 'role',
  manager: 'manager',
  updated_at: 'updated_at',
  actions: 'actions',
  searchText: 'searchText',
  changed_at: 'changed_at',
  changer_name: 'changer_name',
  field_name: 'field_name',
  old_value: 'old_value',
  new_value: 'new_value',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  phoneCountryCode: 'phoneCountryCode',
  emergencyPhone: 'emergencyPhone',
  emergencyPhoneCountryCode: 'emergencyPhoneCountryCode',
  countryCode: 'countryCode',
  order_by: 'order_by',
  name: 'name',
  address: 'address',
  status: 'status',
  currentPassword: 'currentPassword',
  updatedAt: 'updatedAt',
  notes: 'notes',
  description: 'description',
  city: 'city',
  state: 'state',
  pincode: 'pincode',
  contactNumber: 'contactNumber',
  primaryContactPerson: 'primaryContactPerson',
  primaryContactNumber: 'primaryContactNumber',
  primaryContactEmail: 'primaryContactEmail',
  website: 'website',
  gstNumber: 'gstNumber',
  template: 'template',
  file: 'file',
  code: 'code',
  product_division_id: 'product_division_id',
  product_division: 'product_division',
  modify_date: 'modify_date',
  month: 'month',
  year: 'year',
  branch: 'branch',
  uploadedBy: 'uploadedBy',
  user: 'user',
};

export const HEAD_CELL_SORT_DISABLED = {
  productDivisionList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
  productList: [
    VALIDATION_FIELD_MAPPING.actions,
  ],
};

export const HEAD_CELL_LABELS_MAPPING = {
  productDivisionList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('productDivisions.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.description]: translate.t('productDivisions.list.pageTexts.table.columns.description'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('productDivisions.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('productDivisions.list.pageTexts.table.columns.actions'),
  },
  productList: {
    [VALIDATION_FIELD_MAPPING.name]: translate.t('products.list.pageTexts.table.columns.name'),
    [VALIDATION_FIELD_MAPPING.description]: translate.t('products.list.pageTexts.table.columns.description'),
    [VALIDATION_FIELD_MAPPING.product_division]: translate.t('products.list.pageTexts.table.columns.division'),
    [VALIDATION_FIELD_MAPPING.status]: translate.t('products.list.pageTexts.table.columns.status'),
    [VALIDATION_FIELD_MAPPING.modify_date]: translate.t('products.list.pageTexts.table.columns.lastUpdated'),
    [VALIDATION_FIELD_MAPPING.actions]: translate.t('products.list.pageTexts.table.columns.actions'),
  },
};

export const HEAD_CELL_SORT_MAPPING = {
  productDivisionList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.description]: 'description',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
  },
  productList: {
    [VALIDATION_FIELD_MAPPING.name]: 'name',
    [VALIDATION_FIELD_MAPPING.description]: 'description',
    [VALIDATION_FIELD_MAPPING.product_division]: 'product_division',
    [VALIDATION_FIELD_MAPPING.status]: 'is_active',
    [VALIDATION_FIELD_MAPPING.modify_date]: 'modify_date',
  },
};

export const HEAD_CELL_WIDTH_MAPPING = {
  productDivisionList: {
    [VALIDATION_FIELD_MAPPING.name]: '25%',
    [VALIDATION_FIELD_MAPPING.description]: '50%',
    [VALIDATION_FIELD_MAPPING.status]: '15%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
  productList: {
    [VALIDATION_FIELD_MAPPING.name]: '20%',
    [VALIDATION_FIELD_MAPPING.description]: '25%',
    [VALIDATION_FIELD_MAPPING.product_division]: '18%',
    [VALIDATION_FIELD_MAPPING.status]: '10%',
    [VALIDATION_FIELD_MAPPING.modify_date]: '17%',
    [VALIDATION_FIELD_MAPPING.actions]: '10%',
  },
};

export const APP_ERROR_MESSAGES = {
  login: {
    blankUsername: translate.t('login.pageTexts.form.username.errors.required'),
    invalidUsername: translate.t('login.pageTexts.form.username.errors.invalid'),
    blankPassword: translate.t('login.pageTexts.form.password.errors.required'),
    shortPassword: translate.t('login.pageTexts.form.password.errors.lengthShort'),
    longPassword: translate.t('login.pageTexts.form.password.errors.lengthLong'),
  },
  forgotPassword: {
    blankEmail: translate.t('forgotPassword.pageTexts.form.email.errorMessage'),
  },
  resetPassword: {
    blankNewPassword: translate.t('resetPassword.pageTexts.form.newPassword.errors.required'),
    mismatchNewPassword: translate.t('resetPassword.pageTexts.form.newPassword.errors.mismatch'),
    blankConfirmPassword: translate.t(
      'resetPassword.pageTexts.form.confirmPassword.errors.required'
    ),
    mismatchConfirmPassword: translate.t(
      'resetPassword.pageTexts.form.confirmPassword.errors.mismatch'
    ),
    passwordFormat: translate.t('resetPassword.pageTexts.form.newPassword.errors.passwordFormat'),
  },
};

export const APP_SUCCESS_MESSAGES = {
  changePassword: translate.t('changePassword.pageTexts.form.success'),
  forgotPassword: translate.t('forgotPassword.pageTexts.form.success'),
  resetPassword: translate.t('resetPassword.pageTexts.form.success'),
};

export const MaxLength = {
  login: {
    password: 128,
  },
  pageSize: 200,
  common: 100,
};

export const MinLength = {
  login: {
    password: 8,
  },
};

export const LOCAL_STORAGE_KEYS: any = {
  loggedInUser: 'loggedInUser',
  token: 'token',
  theme: 'theme',
  permissions: 'permissions',
  isSystemAdmin: 'isSystemAdmin',
  exception: 'exception',
  loading: 'loading',
  tenantInfo: 'tenantInfo',
  selectedProductId: 'selectedProductId',
  impersonationSession: 'impersonationSession',
};

export const GENERIC_LOOKUP_KEYS = {
  status: 'status',
};
